export const ensureNumber = (num: number, fallback: number) =>
  Number.isFinite(num) || num === Infinity || num === -Infinity
    ? num
    : fallback;
